import { createAction, props } from '@ngrx/store';

export const ERROR_HANDLING = {
	HANDLE_PROJECT_UPDATE_ERROR: createAction(
		'[Error handling] Handle project add or update error',
		props<{ error: any; defaultErrorMessage: string, forAdd: boolean }>()
	),
};
